import { Strategy } from '/builds/pro/webshop/frontend/node_modules/@i18n-micro/path-strategy/dist/no-prefix-strategy.mjs'

const __fullConfig = {"locales":[{"code":"nl","iso":"nl-NL","dir":"ltr","storeCode":"pronto_nl","baseUrl":"https://www.prontowonen.nl","baseDefault":true,"name":"Nederlands","flag":"🇳🇱"},{"code":"nl-be","iso":"nl-BE","dir":"ltr","storeCode":"pronto_be","baseUrl":"https://www.prontowonen.be","baseDefault":false,"name":"Vlaams","flag":"🇧🇪"}],"metaBaseUrl":"/","metaTrustForwardedHost":true,"metaTrustForwardedProto":true,"defaultLocale":"nl","fallbackLocale":"en","localeCookie":"user-locale","autoDetectLanguage":false,"autoDetectPath":"/","strategy":"no_prefix","dateBuild":1793696618411,"hashMode":false,"apiBaseUrl":"x-api/locales","isSSG":false,"disablePageLocales":true,"canonicalQueryWhitelist":["page","sort","filter","search","q","query","tag"],"excludePatterns":[],"routeLocales":{},"routeDisableMeta":{},"globalLocaleRoutes":{},"missingWarn":true,"redirects":false,"hmr":true,"localizedRouteNamePrefix":"localized-","routesLocaleLinks":{},"noPrefixRedirect":false,"debug":false,"cacheMaxSize":0,"cacheTtl":0}

export function getI18nConfig() { return __fullConfig }

export function createI18nStrategy(router) {
  const routerAdapter = {
    hasRoute(name) { return router.hasRoute(name) },
    resolve(to) {
      const r = router.resolve(to)
      return {
        name: r.name != null ? String(r.name) : null,
        path: r.path,
        fullPath: r.fullPath,
        params: r.params || {},
        query: r.query || {},
        hash: r.hash || '',
      }
    },
  }

  return new Strategy({
    strategy: __fullConfig.strategy,
    defaultLocale: __fullConfig.defaultLocale,
    locales: __fullConfig.locales,
    localizedRouteNamePrefix: __fullConfig.localizedRouteNamePrefix,
    globalLocaleRoutes: __fullConfig.globalLocaleRoutes,
    routeLocales: __fullConfig.routeLocales,
    routesLocaleLinks: __fullConfig.routesLocaleLinks,
    noPrefixRedirect: __fullConfig.noPrefixRedirect,
    debug: __fullConfig.debug,
    router: routerAdapter,
    hashMode: __fullConfig.hashMode,
    disablePageLocales: __fullConfig.disablePageLocales,
  })
}
